import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-why-neprop',
  templateUrl: './why-neprop.component.html',
  styleUrls: ['./why-neprop.component.css']
})
export class WhyNepropComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
